
/*
 *   File : notification.js
 *   Author : https://evoqins.com
 *   Description : Notification card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

//  custom packages
import React, { Fragment } from 'react';
import { Icon } from '../Icon';

const NotificationCard = (props) => {
    return (
        <Fragment>
            <div className='padding-16px-all padding-48px-right  d-flex '>
                <div className='position-relative'>
                    <Icon icon='icon-2'
                        size="2.5rem"
                        className="d-flex cursor-pointer " />
                    {props.is_read === false &&
                        <span className="position-absolute top-4px left-80-per translate-middle badge e-border-2px-white  rounded-pill e-bg-fire-red padding-4px-all ">
                        </span>
                    }
                </div>

                <div className='padding-16px-left'>
                    <div className='e-primary-font e-font-14 line-height-16px e-font-weight-600 e-text-smoky-black pb-2'>{props.orderTitle}</div>
                    <div className='e-primary-font e-font-14 line-height-16px e-font-weight-600 e-text-davys-grey-light pb-2'>{props.orderDetails}</div>
                    <div className='e-primary-font e-font-14 line-height-16px e-font-weight-600 e-text-blue-violet pb-2 cursor-pointer'
                        onClick={props.handleDetail}>
                        View Details
                    </div>
                    <div className='e-primary-font e-font-10 line-height-12px e-font-weight-400 e-text-davys-grey-light '>{props.orderDate}</div>
                </div>
            </div>

            <div className='e-border-1px-bottom'>

            </div>
        </Fragment>
    )
}

export default NotificationCard;